<template>
  <b-button
    v-if="isSuperadmin || isDownloadAccess"
    :disabled="sendingRequest"
    variant="rounded"
    class="d-flex mt-2"
  >
    <slot />
    <LoaderAnimation v-if="sendingRequest" />
  </b-button>
</template>

<script>
import LoaderAnimation from '@/components/shared/loader-animation';

export default {
  name: 'FaultGrabWaveformButton',
  components: { LoaderAnimation },
  props: {
    isSuperadmin: Boolean,
    isDownloadAccess: Boolean,
    sendingRequest: Boolean
  }
};
</script>
